module.exports = __webpack_public_path__ + "static/media/l.9ef9b05c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/l.mp3
// module id = 101
// module chunks = 0